/**
 * @fileoverview Chamadas: recusar as ligações recebidas pelo WhatsApp e a
 * mensagem enviada ao cliente depois (HandleWAHAWebhookService no backend).
 */

import React from "react";
import { Collapse, TextField } from "@material-ui/core";

import SettingsSection from "../../../components/Settings/SettingsSection";
import SettingItem from "../../../components/Settings/SettingItem";
import { i18n } from "../../../translate/i18n";
import { bindSetting, useDraftSetting } from "../useSettingsArea";
import useSectionStyles from "./sectionStyles";

const t = (key) => i18n.t(`settings.sections.calls.fields.${key}`);

// Os textos citam a variável da mensagem. Ela entra como valor e com
// skipOnVariables: escrita direto no texto, o i18next tentaria preenchê-la e a
// apagaria.
const CONTACT_NAME = "{{contact.name}}";
const withVariable = (key) =>
  i18n.t(`settings.sections.calls.fields.${key}`, {
    variable: CONTACT_NAME,
    interpolation: { skipOnVariables: true },
  });

const Calls = ({ area }) => {
  const classes = useSectionStyles();
  const enabled = area.get("callRejectionEnabled", "disabled") === "enabled";
  const message = useDraftSetting(area, "callRejectionMessage");

  return (
    <SettingsSection>
      <SettingItem
        toggle
        {...bindSetting(area, "callRejectionEnabled", "disabled")}
        id="callRejection"
        title={t("callRejection.title")}
        description={t("callRejection.description")}
      />
      <Collapse in={enabled} unmountOnExit>
        <SettingItem
          id="callRejectionMessage"
          stacked
          divider
          title={t("callRejectionMessage.title")}
          description={withVariable("callRejectionMessage.description")}
          loading={message.saving}
          saved={message.saved}
        >
          <TextField
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            value={message.value}
            onChange={message.onChange}
            onBlur={message.flush}
            placeholder={withVariable("callRejectionMessage.placeholder")}
            className={classes.field}
            inputProps={{ "aria-labelledby": "setting-callRejectionMessage-title" }}
          />
        </SettingItem>
      </Collapse>
    </SettingsSection>
  );
};

export default Calls;
